import { createStore } from "vuex";
import userStore from '@/store/modules/userStore';
import uiStore from '@/store/modules/uiStore';

export default createStore({
  modules: {
    userStore,
    uiStore,
  },
});
